module.exports = __webpack_public_path__ + "static/media/Presentation.5c94ba73.svg";